var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getCurrentUser from '../../requests/user/getCurrentUser';
import Session from '../../services/Session';
import UserModel from '../../models/UserModel';
/**
 *
 */
var GetCurrentUserCommand = /** @class */ (function (_super) {
    __extends(GetCurrentUserCommand, _super);
    function GetCurrentUserCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @return {*}
     */
    GetCurrentUserCommand.prototype.execute = function () {
        var promise = getCurrentUser();
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    GetCurrentUserCommand.prototype.then = function (response) {
        Session.user = new UserModel(response);
    };
    return GetCurrentUserCommand;
}(Command));
export default GetCurrentUserCommand;
